var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoTop879E6D5A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 40,
    viewBox: "0 0 100 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_52551",
    "data-name": "Group 52551",
    transform: "translate(-1232 -8245)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_21922",
    "data-name": "Rectangle 21922",
    transform: "translate(1232 8245)",
    fill: "#fff",
    stroke: "#d7d9e2",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 40,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 39,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_52552",
    "data-name": "Group 52552"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21924",
    "data-name": "Rectangle 21924",
    width: 25,
    height: 6,
    rx: 3,
    transform: "translate(1270 8273)",
    fill: "#d7d9e2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_21923",
    "data-name": "Rectangle 21923",
    transform: "translate(1263 8252)",
    fill: "#fff",
    stroke: "#007aff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 16,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 38,
    height: 15,
    rx: 1.5,
    fill: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTop879E6D5A);
export default __webpack_public_path__ + "static/media/logo-top.879e6d5a.fb5e9add24526b1808a10c03b45ace5a.svg";
export { ForwardRef as ReactComponent };